import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Space, Button, Form, Input, message, Typography } from 'antd'
import StorageUtils from '../../utils/StorageUtils'

import { reqAccountInfo, reqAccountUpdate } from '../../api'

const { Title } = Typography

class AccountEdit extends React.Component {
    state = {
        username: '',
        email: '',
        first_name: '',
        last_name: ''
    }

    formRef = React.createRef()

    onFinish = async (values) => {
        const result = await reqAccountUpdate(values)
        if (result.code === 0) {
            message.success('Account Update Success!')
            this.props.history.push('/user/account')
        } else {
            message.error(result.message)
        }
    }

    async componentDidMount() {
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)
        this.props.setPathSnippetsState(pathSnippets)

        const user = StorageUtils.getUser()
        const result = await reqAccountInfo(user.refresh)
        if (result.code === 0) {
            this.formRef.current.setFieldsValue({
                username: result.data.username,
                email: result.data.email,
                first_name: result.data.first_name,
                last_name: result.data.last_name
            })
            
        } else {
            message.error(result.message)
        }
    }

    render() {
        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 12 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 6, span: 12 },
        }

        return (
            <Row justify="center">
                <Col span={10}>
                    <Row justify="center">
                        <Col span={12}>
                            <Title level={3}>User Account Edit</Title>
                        </Col>
                    </Row>
                    <Form {...layout} name="account-edit" ref={this.formRef} onFinish={this.onFinish}>
                        <Form.Item name="username" label="Username" rules={[{ required: true }]}>
                            <Input disabled />
                        </Form.Item>
                        <Form.Item name="email" label="E-mail" rules={[{ required: true }]}>
                            <Input disabled />
                        </Form.Item>
                        <Form.Item name="first_name" label="First Name"
                            rules={[
                                {
                                    max: 64,
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item name="last_name" label="Last Name"
                            rules={[
                                {
                                    max: 64,
                                }
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                                <Button type="primary" htmlType="button" href="/user/account">
                                    Cancle
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }
}

AccountEdit.propTypes = {
    setUserState: PropTypes.func,
    setPathSnippetsState: PropTypes.func
}

export default AccountEdit